import React from 'react'
import useStyles from '../../hooks/useStyles'
import styles from './CartPage.module.scss'
import Cart from '../../components/cart/Cart'

function CartPage() {
    const cs = useStyles(styles)



    const arr = [3,5,1,6,10,20,4,2]

    // selection sort
    for (let i = 0; i < arr.length - 1; i++) {
      let minIndex = i
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[j] < arr[minIndex]) {
          minIndex = j
        }
      }
      let temp = arr[i]
      arr[i] = arr[minIndex]
      arr[minIndex] = temp
    }

    // bubble sort
    for (let i = 0; i < arr.length - 1; i++) {
      for (let j = 0; j < arr.length - 1; j++) {
        if (arr[j] < arr[j + 1]) {
          let temp = arr[j]
          arr[j] = arr[j + 1] 
          arr[j + 1] = temp
        }
      }
    }

    console.log(arr)

  return (
    <div className={cs('box-cart')}>
        <div className='container'>
          <Cart />
        </div>
    </div>
  )
}

export default CartPage